import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';

import {
  broadcastCursorFromActionPM
} from "./redux/actions/index";

function ConnectedCursorFromActionWrapper({
  user, socket, cursorFromActionPM
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (socket && user && cursorFromActionPM) {
      socket.emit("broadcast cursor from action", cursorFromActionPM);
      dispatch(broadcastCursorFromActionPM(null));
    }
  }, [socket, user, dispatch, cursorFromActionPM])
  return null;
}

const CursorFromActionWrapper = connect(
  state => ({
    user: state.user,
    socket: state.socketPM,
    cursorFromActionPM: state.cursorFromActionPM
  })
)(ConnectedCursorFromActionWrapper);

export default CursorFromActionWrapper;
